/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserMigrationMigrateRoleRequest
 */
export interface UserMigrationMigrateRoleRequest {
    /**
     * 
     * @type {any}
     * @memberof UserMigrationMigrateRoleRequest
     */
    roleId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof UserMigrationMigrateRoleRequest
     */
    description?: string | null;
    /**
     * 
     * @type {any}
     * @memberof UserMigrationMigrateRoleRequest
     */
    organizationId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserMigrationMigrateRoleRequest
     */
    userConfirmation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserMigrationMigrateRoleRequest
     */
    userOrganizationConfirmation?: boolean;
}

/**
 * Check if a given object implements the UserMigrationMigrateRoleRequest interface.
 */
export function instanceOfUserMigrationMigrateRoleRequest(value: object): value is UserMigrationMigrateRoleRequest {
    return true;
}

export function UserMigrationMigrateRoleRequestFromJSON(json: any): UserMigrationMigrateRoleRequest {
    return UserMigrationMigrateRoleRequestFromJSONTyped(json, false);
}

export function UserMigrationMigrateRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMigrationMigrateRoleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'roleId': json['roleId'] === undefined ? undefined : json['roleId'] === null ? null : json['roleId'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'organizationId': json['organizationId'] === undefined ? undefined : json['organizationId'] === null ? null : json['organizationId'],
        'userConfirmation': json['userConfirmation'] == null ? undefined : json['userConfirmation'],
        'userOrganizationConfirmation': json['userOrganizationConfirmation'] == null ? undefined : json['userOrganizationConfirmation'],
    };
}

export function UserMigrationMigrateRoleRequestToJSON(json: any): UserMigrationMigrateRoleRequest {
    return UserMigrationMigrateRoleRequestToJSONTyped(json, false);
}

export function UserMigrationMigrateRoleRequestToJSONTyped(value?: UserMigrationMigrateRoleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roleId': value['roleId'],
        'description': value['description'],
        'organizationId': value['organizationId'],
        'userConfirmation': value['userConfirmation'],
        'userOrganizationConfirmation': value['userOrganizationConfirmation'],
    };
}

